import {useEffect, useState} from "react";
import {getSearchFilter, setSearchFilter} from "../modules/auth-persistor";
import Loading from "./loading";
import {useNotifyEventsService} from "../services/notify-events-service";
import {AppEvents} from "../utils/constants";
import {useLocation, useNavigate} from "react-router-dom";

export default function ActiveFilters( {onChange=null, ...props} ){

    const [filter, _setFilter] = useState(null);
    const [loading, setLoading] = useState(false);

    const nes = useNotifyEventsService();
    const navigate = useNavigate();
    const location = useLocation();

    function setFilter(newFilter, trigger=true){
        _setFilter(newFilter);
        setSearchFilter(newFilter);
        if (trigger && 'function' === typeof onChange){
            nes.trigger(AppEvents.searchFilterChanged, newFilter);
            onChange(newFilter);
        }
    }

    function resetFilter(keys){
        const newFilter = Object.assign({}, filter);
        const queryFilterParams = new URLSearchParams(location.search);
        let queryFilterParamsChanged = false;
        keys.map((k)=> {

            //we remove query params if we remove active filter. if we didnt, they could be set again on redraw.
            let filterParamKey = k;
            if (k==='search'){
                filterParamKey='keyword';
            }
            if (queryFilterParams.has(filterParamKey)){
                queryFilterParamsChanged = true;
                queryFilterParams.delete(filterParamKey);
            }

            newFilter[k] = null;
            return k;
        })

        if (queryFilterParamsChanged){
            setFilter(newFilter, false);
            navigate({
                pathname: location.pathname,
                search: queryFilterParams.toString()
            }, {replace: true});
            nes.trigger(AppEvents.searchFilterChanged, newFilter);
        } else {
            setFilter(newFilter);
        }

    }

    //init position as its needed for map init
    useEffect(() => {
        let f = getSearchFilter();
        if (f){
            setFilter(f, false);
        }
        nes.on(AppEvents.searchFilterChanged, reloadInternalFilter);
    }, [])

    function reloadInternalFilter(){
        _setFilter(getSearchFilter());
    }

    return (
        <>
            {loading===true && <Loading />}

            {!loading && <div className="d-flex gap-2 flex-wrap">

                {(filter?.categories || filter?.search || filter?.datetimeFrom || filter?.datetimeTo) && <>
                    <div className={"col-12 bg-warning-subtle p-3 rounded-3 mb-2"}>
                        <span className="me-2">Active filters:</span>
                        {filter?.categories && <a onClick={() => resetFilter(['categories'])} className='clickable badge bg-primary p-2 m-1 router-link'>Category <span className="mdi mdi-close"></span></a>}
                        {filter?.search && <a onClick={() => resetFilter(['search'])} className='clickable badge bg-primary p-2 m-1 router-link'>Search active <span className="mdi mdi-close"></span></a>}
                        {filter?.datetimeFrom && <a onClick={() => resetFilter(['datetimeFrom'])} className='clickable badge bg-primary p-2 m-1 router-link'>From date <span className="mdi mdi-close"></span></a>}
                        {filter?.datetimeTo && <a onClick={() => resetFilter(['datetimeTo'])} className='clickable badge bg-primary p-2 m-1 router-link'>To date <span className="mdi mdi-close"></span></a>}
                    </div>
                </>}

            </div>}

        </>
    );
}
